import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Page } from "../../components/page-base";
import {
  instagramApi,
  INSTAGRAM_PENDING_KEY,
  INSTAGRAM_RETURN_KEY,
} from "../profiles-tracking/services/instagram";

const readSession = (key: string) => {
  try {
    const v = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return v;
  } catch {
    return null;
  }
};

export const InstagramCallbackPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handledRef = useRef(false);
  const [message, setMessage] = useState("Conectando o Instagram…");

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    const denied = params.get("error");
    readSession(INSTAGRAM_PENDING_KEY);
    const back = readSession(INSTAGRAM_RETURN_KEY) || "/profiles-tracking";

    if (denied || !code || !state) {
      toast.info(denied ? "Conexão com o Instagram cancelada." : "O Instagram não devolveu a autorização.");
      navigate(back, { replace: true });
      return;
    }

    instagramApi
      .complete(code, state)
      .then((c) => {
        toast.success(`Instagram @${c.username ?? ""} conectado. Ative a sincronização em Gerenciar Perfil → Instagram.`);
        navigate(back, { replace: true });
      })
      .catch((e: Error) => {
        setMessage(e.message);
        toast.error(e.message);
        setTimeout(() => navigate(back, { replace: true }), 2500);
      });
  }, [location.search, navigate]);

  return (
    <Page.Root>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Page.Loader />
        <p style={{ color: "#5f6368", fontSize: 14 }} role="status">
          {message}
        </p>
      </div>
    </Page.Root>
  );
};
